export const FETCH_STUDENT_EXAMS_SCHEDULE_PENDING   = 'FETCH_STUDENT_EXAMS_SCHEDULE_PENDING'
export const FETCH_STUDENT_EXAMS_SCHEDULE_FULFILLED = 'FETCH_STUDENT_EXAMS_SCHEDULE_FULFILLED'
export const FETCH_STUDENT_EXAMS_SCHEDULE_REJECTED  = 'FETCH_STUDENT_EXAMS_SCHEDULE_REJECTED'
